<template>
    <b-container fluid>
        <app-title :text="`Mi evaluación`" />
        <b-row class="mt-3">
            <b-col>
                <app-my-evaluations-list
                ref="my-evaluatios-list"
                :table-data="tableData"
                :on-change-page="onChangePage"
                @sort="onSort"
                @open-modal-commitments="openModalCommitments"
                ></app-my-evaluations-list>
            </b-col>
        </b-row>
        <b-row v-if="tableLength === 0">
            <b-col>
                <b-alert show
                    >Aún no hay evaluaciones calificadas</b-alert
                >
            </b-col>
        </b-row>

        <!-- inicio de popup -->
        <app-pop-up
            id="evaluation-commitments-form-window"
            title="Registro de mis compromisos"
            size="large"
        >
            <template slot="body">
                <app-evaluation-commitments-form
                    ref="evaluationCommitmentsForm"
                    @success="onSavedCommitments"
                    @error="onError"
                    :evaluation-id="evaluationId"
                ></app-evaluation-commitments-form>
            </template>
            <template slot="buttons">
                <div>
                    <b-btn
                        variant="primary"
                        @click="saveCommitments"
                        :disabled="inProgress"
                    >
                        <i class="fa fa-save"></i> Guardar
                    </b-btn>
                </div>
            </template>
        </app-pop-up>
    </b-container>
</template>
<script>
import appMyEvaluationsList from '../MyEvaluations/MyEvaluationsList'
import appEvaluationCommitmentsForm from '../MyEvaluations/EvaluationCommitmentsForm'
export default {
    components: {
        appMyEvaluationsList,
        appEvaluationCommitmentsForm
    },
    data:() =>({
        evaluationId: 0,
        page: 1,
        tableData: [],
        sortDir: 'desc',
        sortBy: 'created_at',
        tableLength: 0,
    }),
    methods: {
        saveCommitments(){
            this.$refs.evaluationCommitmentsForm.saveCommitments()
        },
        async loadMyEvaluations() {
            try {
                const params = {
                    page: this.page,
                    sortBy: this.sortBy,
                    sortDir: this.sortDir,
                }
                const { data } = await repo.get(
                    `performance-evaluations/${this.user.id}/my-evaluations`,
                    params
                )
                this.tableData = data
                this.tableLength = data.data.length
            } catch (err) {
                this.handleErrors(err)
            }
        },
        onSavedCommitments(data){
            toastr.success(data.msg)
            this.$bus.$emit('evaluation-commitments-form-window.close')
        },
        onError(data){
            toastr.error(data.msg)
            this.$bus.$emit('evaluation-commitments-form-window.close')
        },
        openModalCommitments(evaluationEmployee){
            this.evaluationId = evaluationEmployee.performance_evaluation.id
            this.$bus.$emit('evaluation-commitments-form-window.open')
        },
        onChangePage(page) {
            this.page = page
            this.loadPerformanceEvaluations()
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDir = ctx.sortDir
            this.loadPerformanceEvaluations()
        },
    },
    mounted(){
        this.loadMyEvaluations()
    }
    
}
</script>